import React from "react";
import "./PolicyPage.css";

function PolicyPage() {
  return (
    <div className="policy-container">
      <h1>REACH AI – User Policy & Medical Disclaimer</h1>

      <h2>1. Nature of Service</h2>
      <p>
        REACH AI is an educational and informational health support system.
        It does NOT provide medical diagnosis, treatment, prescription,
        or emergency medical services.
      </p>

      <h2>2. No Doctor–Patient Relationship</h2>
      <p>
        Using REACH AI does NOT create a doctor–patient relationship.
        The responses are generated using artificial intelligence models
        and may contain inaccuracies.
      </p>

      <h2>3. AI Limitations</h2>
      <ul>
        <li>AI may make mistakes.</li>
        <li>Information may be incomplete or outdated.</li>
        <li>Recommendations are generalized and not personalized medical advice.</li>
      </ul>

      <h2>4. Medical Emergency Warning</h2>
      <p>
        If you are experiencing severe symptoms including chest pain,
        breathing difficulty, heavy bleeding, unconsciousness,
        or suicidal thoughts, immediately contact:
      </p>
      <ul>
        <li>Local emergency services (India: 112)</li>
        <li>Nearest government hospital</li>
        <li>Certified medical professional</li>
      </ul>

      <h2>5. User Responsibility</h2>
      <p>
        You agree that you are using this chatbot voluntarily and
        accept full responsibility for how you use the information provided.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        REACH AI, its developers, contributors, institutions,
        hosting providers, and stakeholders shall not be held liable
        for any direct, indirect, incidental, consequential,
        or punitive damages arising from:
      </p>
      <ul>
        <li>Reliance on chatbot responses</li>
        <li>Misinterpretation of information</li>
        <li>Failure to seek professional medical advice</li>
      </ul>

      <h2>7. Data Usage</h2>
      <p>
        Conversations may be processed to improve system performance.
        Sensitive personal medical data should not be shared.
      </p>

      <h2>8. Agreement</h2>
      <p>
        By clicking "I Agree", you confirm that:
      </p>
      <ul>
        <li>You understand the AI limitations.</li>
        <li>You will consult a doctor when necessary.</li>
        <li>You release REACH AI and its stakeholders from liability.</li>
      </ul>

      <h3>
        This platform is for educational purposes only.
      </h3>
    </div>
  );
}

export default PolicyPage;